'use client';

import { useContext } from 'react';
import { JsBasicAppContext } from './JsBasicAppProvider';

export const useJsBasicApp = () => useContext(JsBasicAppContext)!;
